import { Typography } from '@mui/material';
import { Doughnut } from 'react-chartjs-2';
import { Chart, TimeScale, LineController, LineElement, PointElement, LinearScale, ArcElement } from 'chart.js';
import styles from './styles';
import { useAppSelector } from 'hooks/reduxHooks';
import { selectCurrentPatientDailyCheckinData, selectLoading } from 'store/PatientStore/selectors';
import Skeleton from 'react-loading-skeleton';

const options = {
  cutout: '60%',
  plugins: {
    legend: {
      display: false,
    },
  },
  tooltips: {
    enabled: false,
  },
  elements: {
    center: {
      text: 'Total Checkins', // Add the text here
      fontStyle: 'Arial',
      sidePadding: 20,
    },
  },
};

const DoughnutRegionChart = () => {
  const patientDailyCheckin = useAppSelector(selectCurrentPatientDailyCheckinData);
  const patientLoading: any = useAppSelector(selectLoading);
  const data = {
    labels: ['Yes', 'No', 'Skip', 'Remaining Days'],
    datasets: [
      {
        data: [
          patientDailyCheckin?.data?.recommendationProgressData?.yes ?? 0,
          patientDailyCheckin?.data?.recommendationProgressData?.no ?? 0,
          patientDailyCheckin?.data?.recommendationProgressData?.skip ?? 0,
          patientDailyCheckin?.data?.recommendationProgressData?.remainingDays ?? 0,
        ],
        backgroundColor: ['#36A2EB', '#FF6384', '#FFCE56', '#4BC0C0'],
        hoverBackgroundColor: ['#36A2EB', '#FF6384', '#FFCE56', '#4BC0C0'],
      },
    ],
  };

  Chart.register(TimeScale, PointElement, LineController, LineElement, LinearScale, ArcElement);
  return (
    patientLoading ?
    <Skeleton height={225} width={350} />
    :
    <div style={{ paddingTop: '20px' }}>
      <Typography sx={{ fontSize: 18, fontWeight: '600', color: '#161728', paddingBottom: '16px' }}>
        Exercise Adherence Progress Chart
      </Typography>
      <div className="chart-container" style={styles.doughnutChartContainer}>
        <div style={styles.doughnutContainer}>
          <Typography style={styles.innerCenterText}>{'Total\nCheckins\n'}
            <span style={styles.innerTextSpan}>{
              patientDailyCheckin?.data?.recommendationProgressData?.totalCheckIns ?? 0
            }</span>
          </Typography>
          <Doughnut data={data} options={options as any} />
        </div>
        <div style={{ ...styles.labelContainer, width: '100%', height: '100%', flexDirection: 'column', alignItems: 'flex-start', marginTop: '10px' }}>
          {data.labels.map((label, index) => (
            <div key={index} style={styles.labelContainer}>
              <div style={{ ...styles.colorDot, backgroundColor: data.datasets[0].backgroundColor[index] }}></div>
              <span style={styles.labelText}>{label}</span>
              <span style={styles.valueText}>{data.datasets[0].data[index]}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DoughnutRegionChart;
